export default function Comment({
  OpenNext,
  setOpenNext,
  setComment,
  comment,
  handleCommentSubmit,
  LeadC,
  setLeadC,
}) {
  const handleCancel1 = () => {
    setOpenNext(false);
    setComment("");
    setLeadC("");
  };

  let LeadJson = [
    "Apply Immediately",
    "Prospective",
    "Eligible",
    "Not Eligible",
    "Opened By Mistake",
  ];

  const handleDelete = () => {
    setOpenNext(false);
  };

  return (
    <div
      id="CreatContact"
      className={OpenNext ? "overlay-note w-100" : "overlay-note"}
      style={{ top: "", zIndex: "100" }}
    >
      <div className="overlay-note-content mblVwe">
        <div className="note-title">
          <h4 className="text-left text-white pl-3">Leave a Comment</h4>
          <div className="closebtn">
            {/* <a id="hide-note-max" className="text-right text-white">
              <i className="fas fa-minus"></i>
            </a> */}
            <a
              className="text-right text-white"
              onClick={() => handleCancel1(false)}
            >
              <i className="fas fa-times"></i>
            </a>
          </div>
        </div>
        <div
          style={{ padding: "20px" }}
          className="Send_Email_Form"
          id="noteBody"
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <div style={{ width: "100%" }} className="d-flex flex-column">
              <div className="bg-light  mt-2">
                <div className="d-flex flex-row align-items-start">
                  <img
                    className="rounded-circle"
                    src="/assets/img/Deafult-user.png"
                    alt=""
                    width="40"
                  />
                  <textarea
                    style={{ border: "1px sold grey" }}
                    className="form-control ml-1 shadow-none textarea"
                    rows="6"
                    placeholder="Write your comment..."
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                  ></textarea>
                </div>
              </div>
              <div style={{ display: "flex", gap: "10px", padding: "10px 0" }}>
                {LeadJson?.map((ev) => (
                  <div
                    className={
                      LeadC == ev ? "prospective Active" : "prospective"
                    }
                    onClick={(e) => {
                      setLeadC(ev);
                      handleCommentSubmit(e, ev);
                    }}
                  >
                    {ev}
                  </div>
                ))}
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
              }}
            >
              {/* <button
                className="cst_btn"
                onClick={(e) => handleCommentSubmit(e)}
              >
                Add
              </button>{" "} */}
              <button className="cst_btn" onClick={() => handleCancel1()}>
                Cancel
              </button>{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
